import apiService from '../../apiService'

export default {
  namespaced: true,

  state: {
    stock: null,
    fetching: true
  },
  mutations: {
    setStock (state, stock) {
      state.stock = stock
    }
  },
  actions: {
    fetch ({ state, commit }, stockId) {
      state.fetching = true

      apiService.getStock(stockId)
        .then(response => {
          commit('setStock', response.data)

          state.fetching = false
        })
        .catch(() => {
          state.fetching = false
        })
    }
  }
}
